import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";

class AdminPagarmeSubscriptionsModule extends HttpFactory {
  async getSubscription(providerSubscriptionId: string): Promise<any[]> {
    return await this.get<any[]>(
      `${ENDPOINTS.ADMIN.PAYMENT.PAGARME_PROXY.SUBSCRIPTIONS}${providerSubscriptionId}`,
    );
  }
}

export { AdminPagarmeSubscriptionsModule };
